import React, { forwardRef } from "react";
import { IMG_URL } from "configs";

const Video = forwardRef(
  ({ src, autoPlay, loop, muted = true, playsInline = true, ...props }, ref) => {
    return (
      <video
        ref={ref}
        src={`${IMG_URL}/${src}`}
        autoPlay={autoPlay}
        loop={loop}
        muted={muted}
        playsInline={playsInline}
        {...props}
      />
    );
  },
);

export default Video;
